<div class="container mx-auto text-center">
  <span class="close" role="button" tabindex="0" aria-label="Sluiten" mat-dialog-close><mat-icon aria-hidden="true">close</mat-icon></span>
  <div class="justify-center items-center text-center">
    <img src="assets/images/logo-img.svg" alt="BeeFund" class="mx-auto">
    <h1 mat-dialog-title>{{ 'Registreren' | translate }}</h1>
    <p class="text-center">{{ 'Maak een account aan om gebruik te kunnen maken van onze acties.' | translate }}</p>
  </div>
  <form [formGroup]="signUpForm" (ngSubmit)="register()" autocomplete="on">
    <div class="flex flex-col">
      <div class="flex flex-row md:flex-col mr-2">
        <div class="basis-4/5">
          <mat-form-field appearance="fill" floatLabel="auto">
            <mat-label>{{ 'E-mail' | translate }}</mat-label>
            <input matInput type="email" inputmode="email" spellcheck="false" name="email" [placeholder]="'E-mail'|translate" formControlName="email" id="email" autocomplete="username" required>
            <mat-error>
              <div *ngIf="email.invalid && email.errors.required">{{ 'E-mail is verplicht' | translate }}</div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="basis-2/5">
          <mat-form-field appearance="fill" floatLabel="auto">
            <mat-label>{{ 'Voornaam' | translate }}</mat-label>
            <input matInput name="firstname" [placeholder]="'Voornaam'|translate" formControlName="firstname" id="firstname" autocomplete="given-name" required>
            <mat-error>
              <div *ngIf="firstname.invalid && firstname.errors.required">{{ 'Voornaam is verplicht' | translate }}</div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="basis-2/5">
          <mat-form-field appearance="fill" floatLabel="auto">
            <mat-label>{{ 'Achternaam' | translate }}</mat-label>
            <input matInput name="lastname" [placeholder]="'Achternaam'|translate" formControlName="lastname" id="lastname" autocomplete="family-name" required>
            <mat-error>
              <div *ngIf="lastname.invalid && lastname.errors.required">{{ 'Achternaam is verplicht' | translate }}</div>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="basis-4/5">
          <mat-form-field appearance="fill" floatLabel="auto">
          <mat-label>{{ 'Wachtwoord' | translate }}</mat-label>
          <input matInput type="password" name="password" [placeholder]="'Wachtwoord'|translate" formControlName="password" id="password" autocomplete="new-password" minlength="6" required>
          <mat-error>
            <div *ngIf="password.invalid && password.errors.required">{{ 'Wachtwoord is verplicht' | translate }}</div>
            <div *ngIf="password.invalid && !password.errors.required && password.errors.minlength">{{ 'Wachtwoord moet minimaal 6 karakters bevatten' | translate }}</div>
            <div *ngIf="password.invalid && !password.errors.required && !password.errors.minlength && password.errors.pattern">{{ 'Wachtwoord moet een letter en getal bevatten' | translate }}</div>
          </mat-error>
          </mat-form-field>
        </div>
        <p>
          {{ 'Je moet minimaal 16 jaar zijn om je aan te melden. Andere mensen die BeeFund gebruiken, kunnen je geboortedatum niet zien.' | translate }}
        </p>
        <mat-form-field appearance="fill" floatLabel="auto">
          <mat-label>{{ 'Geboortedatum' | translate }}</mat-label>
          <input matInput type="date" name="dateOfBirth" [placeholder]="'Geboortedatum'|translate" formControlName="dateOfBirth" id="dateOfBirth" autocomplete="bday" required>
          <mat-error>
            <div *ngIf="dateOfBirth.invalid && dateOfBirth.errors.required">{{ 'Geboortedatum is verplicht' | translate }}</div>
            <div *ngIf="dateOfBirth.invalid && !dateOfBirth.errors.required && dateOfBirth.errors.invalidAge">{{ 'Ongeldige datum' | translate }}</div>
            <div *ngIf="dateOfBirth.invalid && !dateOfBirth.errors.required && dateOfBirth.errors.age">{{ 'Je moet minimaal 16 zijn' | translate }}</div>
          </mat-error>
        </mat-form-field>
        <mat-checkbox id="optIn" color="primary" formControlName="optIn">{{ 'Houd mij op de hoogte van nieuwe aanbiedingen!' | translate }}</mat-checkbox>
      </div>
      <div class="flex flex-col justify-center items-center content-center margin-right-10">
        <p><span>{{ 'Door het aanmaken van een BeeFund account ga je akkoord met ons' | translate }} </span> <a class="privacy" href="/privacy" target="_blank" rel="noopener noreferrer">{{ 'privacybeleid' | translate }}</a>.</p>
        <button mat-raised-button type="submit" color="accent" [disabled]="signUpForm.invalid">{{'Registreren'|translate}}</button>
        <p><span>{{ 'Al een account?' | translate }} </span> <a role="button" tabindex="0" mat-dialog-close="login"> {{ 'Inloggen' | translate }}</a></p>
      </div>
    </div>
  </form>
</div>